import React from 'react'
import { IExpenseDefinitionModel } from './ExpenseModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'

type Props = {
  data: IExpenseDefinitionModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (expense: IExpenseDefinitionModel) => void
  onDelete?: (expense: IExpenseDefinitionModel) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const ExpenseTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const expenseColumns: TableColumn<IExpenseDefinitionModel>[] = [
    {
      key: 'name',
      label: 'Gider Tanımı',   // Başlık normal kalacak
      sortable: true,
      render: (item, value) => (
        <span className="text-primary">{value}</span>  // Sadece hücreler mavi
      ),
    },
    { 
      key: 'expenseType', 
      label: 'Gider Türü',
    },
  ]

  const expenseActions: TableAction<IExpenseDefinitionModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (expense) => onEdit?.(expense),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (expense) => onDelete?.(expense),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={expenseColumns}
      actions={expenseActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz gider tanımı bulunamadı'
    />
  )
}
